import React, { useContext, useState } from 'react';

import classnames from 'classnames';
import _ from 'lodash';

import { PopupContext } from '@app/dev/contexts/popup';
import { useTranslation } from '@common/hooks/translation';

import { getStepsList } from './stepsConfig';

import './style.scss';
import Config from '@app/dev/config/main';
import { POPUPS } from '@common/constants/popups';
import { createTerminalPlayer } from '@app/dev/helpers/user/createTerminalPlayer';

const SignUp = () => {
  const t = useTranslation();
  const [{ closePopup, openPopup }] = useContext(PopupContext);

  const [form, setForm] = useState({
    customPhoneNumber: {
      code: Config.main.registartionCustomField.phoneCode,
      phone: '',
    },
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);

  const steps = getStepsList();
  const stepData = steps[currentStep].step;
  const isLastStep = currentStep === steps.length - 1;

  const onContinue = async () => {
    const formErrors = stepData.validate(form);

    setErrors(formErrors);

    if (!_.isEmpty(formErrors)) return;

    if (!isLastStep) {
      setCurrentStep(currentStep + 1);
      return;
    }

    setLoading(true);

    const res = await createTerminalPlayer(form);

    if (res?.errors) setErrors(res.errors);
    setLoading(false);
  };

  const onBack = () => {
    if (currentStep === 0) closePopup();

    setCurrentStep(currentStep - 1);
  };

  const StepComponent = stepData.component;

  return (
    <div className={`popup-content popup-small popup-${steps[currentStep].name}`}>
      <p className="popup-title">{t('REGISTRATION')}</p>
      <div className="popup-main-content">
        <StepComponent form={form} setForm={setForm} errors={errors} setErrors={setErrors} />
      </div>
      <div className="popup-actions">
        <button
          onClick={onBack}
          className="popup-cancel-button"
          type="button"
        >
          {
            currentStep === 0
              ? t('Close')
              : (
                <>
                  <i className="global-icon icon-arrow-line-left button-icon left" />
                  {t('Back')}
                </>
              )
          }
        </button>
        <button
          type="button"
          onClick={onContinue}
          className={classnames('popup-confirm-button', { disabled: loading })}
        >
          {t(isLastStep ? 'Submit' : 'Next')}
          {/* <i className="global-icon icon-arrow-line-right button-icon" /> */}
        </button>
      </div>
      {Config.main.enableRegistration && (
        <div
          className="sign-in"
        >
          {t('have an account?')}
          &nbsp;
          <span onClick={() => openPopup(POPUPS.SIGN_IN, { signInToAdmin: false })}>{t('sign in')}</span>
        </div>
      )}
    </div>
  );
};

export default SignUp;
